var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserPurple = function SvgUserPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "user-purple_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.667 0h32v32h-32z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#user-purple_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.467 22.801c1.133-.866 2.4-1.55 3.8-2.05 1.4-.5 2.866-.75 4.4-.75 1.533 0 3 .25 4.4.75 1.4.5 2.666 1.184 3.8 2.05a10.316 10.316 0 0 0 1.817-3.1 10.46 10.46 0 0 0 .65-3.7c0-2.955-1.04-5.472-3.117-7.55-2.078-2.078-4.595-3.116-7.55-3.116-2.956 0-5.472 1.038-7.55 3.116C7.04 10.529 6 13.046 6 16c0 1.311.217 2.545.65 3.7a10.294 10.294 0 0 0 1.817 3.1Zm8.2-5.466c-1.312 0-2.417-.45-3.318-1.35-.9-.9-1.35-2.006-1.35-3.317 0-1.311.45-2.417 1.35-3.317.9-.9 2.006-1.35 3.318-1.35 1.31 0 2.416.45 3.317 1.35.9.9 1.35 2.006 1.35 3.317 0 1.311-.45 2.417-1.35 3.317-.9.9-2.006 1.35-3.317 1.35Zm0 12c-1.845 0-3.578-.35-5.2-1.051a13.456 13.456 0 0 1-4.234-2.85c-1.2-1.2-2.15-2.61-2.85-4.233-.7-1.622-1.05-3.355-1.05-5.2 0-1.844.35-3.578 1.05-5.2.7-1.622 1.65-3.033 2.85-4.233 1.2-1.2 2.611-2.15 4.234-2.85 1.622-.7 3.355-1.05 5.2-1.05 1.844 0 3.577.35 5.2 1.05 1.622.7 3.033 1.65 4.233 2.85 1.2 1.2 2.15 2.611 2.85 4.233.7 1.623 1.05 3.356 1.05 5.2 0 1.845-.35 3.578-1.05 5.2a13.457 13.457 0 0 1-2.85 4.234c-1.2 1.2-2.611 2.15-4.233 2.849-1.623.7-3.356 1.05-5.2 1.05Z",
    fill: "#7959D3"
  }))));
};
export default SvgUserPurple;